import { LoadingProgress } from "./LoadingProgress";
import { RenderRequestError } from "./RenderRequestError";

import type { LoadingProps } from "./LoadingProps";
import type { ReactNode } from "react";

import * as styles from "./loading.scss";

interface LoadingProgressTextProps extends LoadingProps {
	text: ReactNode;
	width?: string;
}
export const LoadingProgressText = ({ request, text, width, hideSoftErrors, requests }: LoadingProgressTextProps) => {
	return (
		<RenderRequestError request={request} requests={requests} hideSoftErrors={hideSoftErrors}>
			<div className={styles.loadingProgressText}>
				{(!request || request.isLoading) && <p>{text}</p>}
				<LoadingProgress width={width} request={request} paddingTop={true} />
			</div>
		</RenderRequestError>
	);
};
